"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FloatingArrow", {
  enumerable: true,
  get: function get() {
    return _react.FloatingArrow;
  }
});
Object.defineProperty(exports, "FloatingDelayGroup", {
  enumerable: true,
  get: function get() {
    return _react.FloatingDelayGroup;
  }
});
Object.defineProperty(exports, "FloatingFocusManager", {
  enumerable: true,
  get: function get() {
    return _react.FloatingFocusManager;
  }
});
Object.defineProperty(exports, "FloatingNode", {
  enumerable: true,
  get: function get() {
    return _react.FloatingNode;
  }
});
Object.defineProperty(exports, "FloatingOverlay", {
  enumerable: true,
  get: function get() {
    return _react.FloatingOverlay;
  }
});
Object.defineProperty(exports, "FloatingPortal", {
  enumerable: true,
  get: function get() {
    return _react.FloatingPortal;
  }
});
Object.defineProperty(exports, "FloatingTree", {
  enumerable: true,
  get: function get() {
    return _react.FloatingTree;
  }
});
Object.defineProperty(exports, "arrow", {
  enumerable: true,
  get: function get() {
    return _react.arrow;
  }
});
Object.defineProperty(exports, "autoPlacement", {
  enumerable: true,
  get: function get() {
    return _react.autoPlacement;
  }
});
Object.defineProperty(exports, "autoUpdate", {
  enumerable: true,
  get: function get() {
    return _react.autoUpdate;
  }
});
Object.defineProperty(exports, "computePosition", {
  enumerable: true,
  get: function get() {
    return _react.computePosition;
  }
});
Object.defineProperty(exports, "detectOverflow", {
  enumerable: true,
  get: function get() {
    return _react.detectOverflow;
  }
});
Object.defineProperty(exports, "flip", {
  enumerable: true,
  get: function get() {
    return _react.flip;
  }
});
Object.defineProperty(exports, "getOverflowAncestors", {
  enumerable: true,
  get: function get() {
    return _react.getOverflowAncestors;
  }
});
Object.defineProperty(exports, "hide", {
  enumerable: true,
  get: function get() {
    return _react.hide;
  }
});
Object.defineProperty(exports, "inline", {
  enumerable: true,
  get: function get() {
    return _react.inline;
  }
});
Object.defineProperty(exports, "limitShift", {
  enumerable: true,
  get: function get() {
    return _react.limitShift;
  }
});
Object.defineProperty(exports, "offset", {
  enumerable: true,
  get: function get() {
    return _react.offset;
  }
});
Object.defineProperty(exports, "safePolygon", {
  enumerable: true,
  get: function get() {
    return _react.safePolygon;
  }
});
Object.defineProperty(exports, "shift", {
  enumerable: true,
  get: function get() {
    return _react.shift;
  }
});
Object.defineProperty(exports, "size", {
  enumerable: true,
  get: function get() {
    return _react.size;
  }
});
Object.defineProperty(exports, "useClick", {
  enumerable: true,
  get: function get() {
    return _react.useClick;
  }
});
Object.defineProperty(exports, "useDelayGroup", {
  enumerable: true,
  get: function get() {
    return _react.useDelayGroup;
  }
});
Object.defineProperty(exports, "useDelayGroupContext", {
  enumerable: true,
  get: function get() {
    return _react.useDelayGroupContext;
  }
});
Object.defineProperty(exports, "useDismiss", {
  enumerable: true,
  get: function get() {
    return _react.useDismiss;
  }
});
Object.defineProperty(exports, "useFloating", {
  enumerable: true,
  get: function get() {
    return _react.useFloating;
  }
});
Object.defineProperty(exports, "useFloatingNodeId", {
  enumerable: true,
  get: function get() {
    return _react.useFloatingNodeId;
  }
});
Object.defineProperty(exports, "useFloatingParentNodeId", {
  enumerable: true,
  get: function get() {
    return _react.useFloatingParentNodeId;
  }
});
Object.defineProperty(exports, "useFloatingPortalNode", {
  enumerable: true,
  get: function get() {
    return _react.useFloatingPortalNode;
  }
});
Object.defineProperty(exports, "useFloatingTree", {
  enumerable: true,
  get: function get() {
    return _react.useFloatingTree;
  }
});
Object.defineProperty(exports, "useFocus", {
  enumerable: true,
  get: function get() {
    return _react.useFocus;
  }
});
Object.defineProperty(exports, "useHover", {
  enumerable: true,
  get: function get() {
    return _react.useHover;
  }
});
Object.defineProperty(exports, "useId", {
  enumerable: true,
  get: function get() {
    return _react.useId;
  }
});
Object.defineProperty(exports, "useInteractions", {
  enumerable: true,
  get: function get() {
    return _react.useInteractions;
  }
});
Object.defineProperty(exports, "useListNavigation", {
  enumerable: true,
  get: function get() {
    return _react.useListNavigation;
  }
});
Object.defineProperty(exports, "useRole", {
  enumerable: true,
  get: function get() {
    return _react.useRole;
  }
});
Object.defineProperty(exports, "useTypeahead", {
  enumerable: true,
  get: function get() {
    return _react.useTypeahead;
  }
});
var _react = require("@floating-ui/react");